import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { CompletionNodeData } from '../utils/funnelTypes';

function CompletionNodeComponent({ data, selected }: NodeProps) {
  const { t } = useTranslation('funnel');
  const nodeData = data as unknown as CompletionNodeData;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, delay: 0.3, ease: 'easeOut' }}
      className={`
        relative rounded-xl border bg-[#18181B]/90 backdrop-blur-md shadow-lg
        min-w-[190px] max-w-[210px] overflow-hidden transition-all duration-200
        ${selected ? 'border-emerald-500 shadow-emerald-500/20' : 'border-emerald-500/25 hover:border-emerald-500/50'}
      `}
    >
      <div className="p-3">
        <div className="flex items-center justify-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500/15 ring-1 ring-emerald-500/30">
            <CheckCircle2 className="h-4 w-4 text-emerald-400" />
          </div>
          <div>
            <p className="text-xs font-semibold text-emerald-400">
              {nodeData.label}
            </p>
            <p className="text-[10px] text-zinc-500 truncate max-w-[120px]">
              {nodeData.source}
            </p>
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        className="!w-2 !h-2 !bg-emerald-500 !border-2 !border-[#18181B] !-top-1"
      />
    </motion.div>
  );
}

export const CompletionNode = memo(CompletionNodeComponent);
